import React from "react";
import Footer from "../components/footer";
import { icons } from "../assets/icons";
import { projects } from "../data/data";

const Projects = () => {
  return (
    <div className="App flex flex-col justify-center font-geist">
      <div className="flex flex-col py-8 px-4 w-full max-w-[900px] mx-auto">
        <div>
          <span className="flex items-center gap-2">
            <a
              href="/"
              className="transform transition-transform duration-500 ease-in-out hover:-translate-x-1"
            >
              {icons.arrowLeft}
            </a>
            <span className="font-semibold text-xl">All Projects</span>
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-7">
          {projects.map((project) => (
            <a
              key={project.name}
              className="bg-[#111111] border border-gray-600 py-5 px-3 rounded-lg transform transition-transform hover:-translate-y-0.5 duration-300 flex flex-col"
              href={project.url}
              target="_blank"
              rel="noreferrer"
            >
              <h1 className="font-bold text-md">{project.name}</h1>
              <p className="text-sm my-2">{project.description}</p>
              <p className="text-xs bg-[#f3f4f6] dark:bg-black px-2 py-1 rounded-lg font-mono md:flex-wrap md:break-words">
                {project.link}
              </p>
            </a>
          ))}
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default Projects;
